export const MAIL_REQUEST = 'MAIL_REQUEST'

export function sendMailReport(data) {
    return {
        type: MAIL_REQUEST,
        data
    }
}

export const MAIL_REQUEST_SUCCESS = 'MAIL_REQUEST_SUCCESS'

export function sendMailReportSuccess(data) {
    return {
        type: MAIL_REQUEST_SUCCESS,
        data
    }
}

export const MAIL_REQUEST_ERROR = 'MAIL_REQUEST_ERROR'

export function sendMailReportError() {
    return {
        type: MAIL_REQUEST_ERROR,
    }
}
